import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/categories/profile/loading';

export const Route = createFileRoute('/_private/settings/categories/$id')({
  pendingComponent: Loading,
});
